export const mapkeysConstants = {

    GETALL_REQUEST: 'MAPKEYS_GETALL_REQUEST',
    GETALL_SUCCESS: 'MAPKEYS_GETALL_SUCCESS',
    GETALL_FAILURE: 'MAPKEYS_GETALL_FAILURE',

    UPDATE_REQUEST: 'MAPKEYS_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'MAPKEYS_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'MAPKEYS_UPDATE_FAILURE',
}